<template>
    <div class="text-label">
        <div class="text-label-left">
            <div class="label-large" id="label-text0"><a href="http://sh.jnnccqjyw.cn/" target="_blank">农村产权交易平台</a></div>
            <div class="label-large" id="label-text2"><a href="http://jn.sdncpzl.com/#/" target="_blank">农产品监督管理平台</a></div>
            <div class="label-large" id="label-text4"><a href="http://221.214.107.20:7066" target="_blank">农村三资综合信息管理平台</a></div>
            <div class="label-large" id="label-text6"><a href="http://39.106.122.95:8081/" target="_blank">保农仓智慧农业管理系统</a></div>
        </div>
        <div class="text-label-right">
            <div class="label-small" id="label-text1">畜牧</div>
            <div class="label-small" id="label-text3">蔬菜</div>
            <div class="label-small" id="label-text5">农机</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "textLabel"
}
</script>

<style scoped lang="stylus">
.text-label {
    width 100%
    height 100%
    display flex
    flex-wrap wrap
    justify-content space-around
    padding 15px
    .text-label-left {
        width 65%
        height 100%
        display flex
        flex-wrap wrap
        align-items center
        justify-content space-around
    }
    .text-label-right {
        width 35%
        height 100%
        display flex
        flex-wrap wrap
        align-items center
        justify-content space-around
    }
    .label-large {
        width 280px
        height 55px
        line-height 45px
        text-align center
        color #FFF
        font-size 18px
        background-size 100% 100%
        cursor pointer
    }
    .label-small {
        width 120px
        height 55px
        line-height 45px
        text-align center
        color #FFF
        font-size 18px
        background-size 100% 100%
        cursor pointer
    }
    #label-text0 {
        background-image url("../../assets/img/text_label_4.png")
    }
    #label-text1 {
        background-image url("../../assets/img/text_label_3.png")
    }
    #label-text2 {
        background-image url("../../assets/img/text_label_5.png")
    }
    #label-text3 {
        background-image url("../../assets/img/text_label_2.png")
    }
    #label-text4 {
        background-image url("../../assets/img/text_label_1.png")
    }
    #label-text5 {
        background-image url("../../assets/img/text_label_0.png")
    }
    #label-text6 {
        background-image url("../../assets/img/text_label_6.png")
    }
}
.text-label a {
    color #FFF
}
</style>